module.exports = __webpack_public_path__ + "img/back_btn.4d7f0959.png";